import React from "react";
import {
	StyleSheet,
	Text,
	View,
	Animated,
	TouchableNativeFeedback,
	TouchableWithoutFeedback
} from "react-native";
import {
	shadowStyle,
	alignItemsMap,
	getTouchableComponent,
	isAndroid,
	touchableBackground,
	DEFAULT_ACTIVE_OPACITY
} from "./shared";
import { SCREEN_WIDTH } from "../../styles/commonStyles";

const SHADOW_SPACE = 10;
const TEXT_HEIGHT = 30;

const TextTouchable = isAndroid
	? TouchableNativeFeedback
	: TouchableWithoutFeedback;

export const ActionButtonItem = props => {
	const {
		active = true,
		spaceBetween = 15,
		useNativeFeedback = true,
		activeOpacity = DEFAULT_ACTIVE_OPACITY,
		fixNativeFeedbackRadius = false,
		nativeFeedbackRippleColor = "rgba(255,255,255,0.75)",
		numberOfLines = 1,
		textHeight = TEXT_HEIGHT,
		textContainerStyle,
		hideLabelShadow,
		offsetX = 30,
		parentSize,
		size = 56,
		position = "right",
		verticalOrientation = "up",
		hideShadow,
		spacing = 20
	} = props;

	if (!active) return null;

	const _renderTitle = () => {
		if (!props.title) return null;
		const offsetTop = Math.max(size / 2 - TEXT_HEIGHT / 2, 0);
		const positionStyles = { top: offsetTop };
		const hideShadow =
			hideLabelShadow === undefined ? props.hideShadow : hideLabelShadow;

		if (position !== "center") {
			positionStyles[position] =
				offsetX + (parentSize - size) / 2 + size + spaceBetween;
		} else {
			positionStyles.right = SCREEN_WIDTH / 2 + size / 2 + spaceBetween;
		}

		const textStyles = [
			styles.textContainer,
			{ height: textHeight },
			positionStyles,
			!hideShadow && shadowStyle,
			textContainerStyle
		];

		const title = React.isValidElement(props.title) ? (
			props.title
		) : (
			<Text
				allowFontScaling={false}
				style={[styles.text, props.textStyle]}
				numberOfLines={numberOfLines}
			>
				{props.title}
			</Text>
		);

		return (
			<TextTouchable
				rejectResponderTermination
				background={touchableBackground(
					nativeFeedbackRippleColor,
					fixNativeFeedbackRadius
				)}
				activeOpacity={activeOpacity || DEFAULT_ACTIVE_OPACITY}
				onPress={props.onPress}
			>
				<View style={textStyles}>{title}</View>
			</TextTouchable>
		);
	};

	const animatedViewStyle = {
		marginBottom: -SHADOW_SPACE,
		alignItems: alignItemsMap[position],

		// backgroundColor: props.buttonColor,
		opacity: props.anim,
		transform: [
			{
				translateY: props.anim?.interpolate({
					inputRange: [0, 1],
					outputRange: [verticalOrientation === "down" ? -40 : 40, 0]
				})
			}
		]
	};

	const buttonStyle = {
		justifyContent: "center",
		alignItems: "center",
		width: size,
		height: size,
		borderRadius: size / 2,
		backgroundColor: props.buttonColor || props.btnColor
	};

	if (position !== "center") buttonStyle[position] = (parentSize - size) / 2;

	const Touchable = getTouchableComponent(useNativeFeedback);

	const parentStyle =
		isAndroid && fixNativeFeedbackRadius
			? {
					height: size,
					marginBottom: spacing,
					right: offsetX,
					borderRadius: props.size / 2
			  }
			: {
					paddingHorizontal: offsetX,
					height: size + SHADOW_SPACE + spacing
			  };

	return (
		<Animated.View
			pointerEvents="box-none"
			style={[animatedViewStyle, parentStyle]}
		>
			<View>
				<Touchable
					rejectResponderTermination
					testID={props.testID}
					accessibilityLabel={props.accessibilityLabel}
					background={touchableBackground(
						nativeFeedbackRippleColor,
						fixNativeFeedbackRadius
					)}
					activeOpacity={activeOpacity || DEFAULT_ACTIVE_OPACITY}
					onPress={props.onPress}
				>
					<View
						style={[
							buttonStyle,
							!hideShadow ? { ...shadowStyle, ...props.shadowStyle } : null
						]}
					>
						{props.children}
					</View>
				</Touchable>
			</View>
			{_renderTitle()}
		</Animated.View>
	);
};

const styles = StyleSheet.create({
	textContainer: {
		position: "absolute",
		paddingVertical: isAndroid ? 2 : 3,
		paddingHorizontal: 8,
		borderRadius: 3,
		borderWidth: StyleSheet.hairlineWidth,
		borderColor: "#eee",
		backgroundColor: "white"
	},
	text: {
		flex: 1,
		fontSize: 12,
		color: "#444"
	}
});
